import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

/**
 * Resets window scroll to the top on every forward navigation. SPA route
 * changes don't touch scroll position by default, so without this you'd
 * land mid-page when navigating from a scrolled list (home slider → course
 * page is the canonical case).
 *
 * `useNavigationType()` returns "POP" for back/forward button presses — we
 * leave those alone so returning users land where they left off.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    if (navigationType === "POP") return;
    window.scrollTo({ top: 0, left: 0, behavior: "instant" as ScrollBehavior });
  }, [pathname, navigationType]);

  return null;
}
